import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@mui/material/styles";
import CloseBtn from "src/Assets/images/CloseButton.svg";
import {
  Button as MuiButton,
  Dialog,
  DialogTitle,
  IconButton,
  Modal,
  Box,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import EditMap from "src/Components/DefaultCommunity/editMap";
import MapIcon from "src/Assets/images/MapIcon.svg";
import * as moderatorActions from "src/store/actions/Moderator/moderatoractions";
import Api from "src/network";
import CommunityImage from "src/Assets/images/ComImage.svg";
import Camera from "src/Assets/images/camera.svg";
import styles from "./CommunityInfo.module.css";
import { compressFile } from "src/Utils/imageCompressionUtil";

const Button = styled(MuiButton)({
  paddingLeft: "25px",
  paddingRight: "25px",
  marginTop: "20px",
  marginBottom: "20px",
  alignSelf: "center",
});

const useStyles = makeStyles({
  paperWidthSm: {
    padding: "20px 15px 15px 15px",
    borderRadius: "25px",
    width: "800px",
    // maxWidth: '800px',
    height: "500px",
    overflow: "hidden",
    maxWidth: "800px !important",
  },
});

function CommunityInfoInput({
  placeholdertext,
  labelText,
  styleClass,
  parentStyleClass,
  country_list,
  state_list,
  value,
  onChangeHandler,
  isInputTextHandler,
  charLength,
}) {
  const onValChange = (e) => {
    const newValue = e.target?.value || "";
    let value;
    if (labelText === "Zip Code") {
      value = newValue; //newValue.replace(/\D/g, ""); // Remove non-numeric characters
    } else {
      value = newValue; // Allow all characters for other inputs
    }
    onChangeHandler(value);
  };

  return (
    <div
      className={`${
        parentStyleClass ? parentStyleClass : "communityInfo-input"
      }`}
    >
      <form>
        <p
          className={
            ["Address", "City", "State", "Zip Code"].includes(labelText)
              ? styles.labelName
              : styles.labelNameDefault
          }
        >
          {labelText}:<span className={styles.importantMark}>*</span>
        </p>
        {isInputTextHandler ? (
          <textarea
            placeholder={placeholdertext}
            className={styleClass}
            value={value}
            onChange={onValChange}
            maxLength={charLength}
          />
        ) : labelText === "Country" ? (
          <Dropdown
            className={styles.CountryStateDropdown}
            options={country_list}
            onChange={onValChange}
            value={value}
          />
        ) : labelText === "State" ? (
          <Dropdown
            className={styles.CountryStateDropdown}
            options={state_list}
            onChange={onValChange}
            value={value}
          />
        ) : (
          <input
            placeholder={placeholdertext}
            className={styleClass}
            value={value}
            maxLength={labelText === "Zip Code" ? 15 : 280}
          />
        )}
      </form>
    </div>
  );
}

const CommunityInfo = (props) => {
  const classes = useStyles();
  const [countries, setCountries] = React.useState([]);
  const [statesList, setStatesList] = React.useState([]);
  const [comName, setComName] = React.useState("");
  const [comDescription, setComDescription] = React.useState("");
  const [comAddress, setComAddress] = React.useState("");
  const [comCity, setComCity] = React.useState("");
  const [comZipcode, setComZipCode] = React.useState("");
  const [comState, setComState] = React.useState("");
  const [comCountry, setComCountry] = React.useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [editCommunityItem, setEditCommunityItem] = useState({});
  const [tenant_list, setTenant_list] = useState({});
  const [community_tenant_list, setCommunity_tenant_list] = useState([]);
  const [tenantLat, setTenantLat] = useState("");
  const [tenantLng, setTenantLng] = useState("");
  const [file, setFile] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [openErrorModal, setOpenErrorModal] = useState(false);

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const ImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  useEffect(() => {
    fetchTenantList();
    setFile(null);
  }, [props.tenantId]);

  const fetchTenantList = async () => {
    try {
      const res = await Api.getTenantList();
      setCommunity_tenant_list(res?.data?.tenantList || []);
      setTenant_list(res?.data?.statesList || {});
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (community_tenant_list) {
      const filtered = community_tenant_list.filter(
        (item) => Number(item.id) === props.tenantId
      )[0];
      console.log(community_tenant_list);
      console.log(`filtered:`, filtered);
      console.log("-------------------------------");

      if (filtered) {
        setEditCommunityItem({
          ...filtered,
          changedLatitude: null, // Add initial value or null
          changedLongitude: null, // Add initial value or null
        });
      }
      // setEditCommunityItem(filtered);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [community_tenant_list, props.tenantId]);

  useEffect(() => {
    const {
      name,
      description,
      city,
      address1,
      zipcode,
      country,
      state,
      tenantLatitude,
      tenantLangitude,
      changedLatitude,
      changedLongitude,
    } = editCommunityItem || {};
    setComName(name || "");
    setComAddress(address1 || "");
    setComCity(city || "");
    setComDescription(description || "");
    setComZipCode(zipcode || "");
    setComCountry(country || "");
    setComState(state || "");
    // setTenantLat(changedLatitude || tenantLatitude || "");
    // setTenantLng(changedLongitude || tenantLangitude || "");
    setTenantLat(changedLatitude || "");
    setTenantLng(changedLongitude || "");
  }, [editCommunityItem]);

  useEffect(() => {
    let countryArray = [];
    if (tenant_list && Object.keys(tenant_list).length !== 0) {
      // eslint-disable-next-line array-callback-return
      Object.keys(tenant_list).map((country) => {
        countryArray.push(country);
      });
    }
    setCountries([...countryArray]);
  }, [tenant_list]);

  useEffect(() => {
    if (tenant_list && Object.keys(tenant_list).length !== 0) {
      setStatesList(tenant_list[comCountry]);
    }
  }, [comCountry]);

  const onSubmit = (e) => {
    e.preventDefault();
  };

  const mapCommunity = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    setFieldErrors({});
  };

  const onCountryChange = (value) => {
    setComCountry(value);
    setComState("");
  };

  const onStateChange = (value) => {
    setComState(value);
  };

  const validateFields = () => {
    let errors = {};

    if (comName === "") errors.comName = "Please enter the community name.";
    if (comDescription === "")
      errors.comDescription = "Please provide a description.";
    if (comCountry === "") errors.comCountry = "Please select a country.";
    if (comState === "") errors.comState = "Please select a state.";
    if (comAddress === "")
      errors.comAddress = "Please enter the community address.";
    if (comCity === "") errors.comCity = "Please enter the city.";
    if (comZipcode === "") errors.comZipcode = "Please enter the zipcode.";

    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      setOpenErrorModal(true);
      return false;
    }

    return true;
  };

  const getLatLng = (data) => {
    if (data && Object.keys(data).length > 0) {
      setTenantLat(data.lat.toString());
      setTenantLng(data.lng.toString());
      // Update `editCommunityItem` with `changedLatitude` and `changedLongitude`
      setEditCommunityItem((prevItem) => ({
        ...prevItem,
        changedLatitude: data.lat.toString(),
        changedLongitude: data.lng.toString(),
      }));
    }
  };

  const onSave = () => {
    const isValid = validateFields();
    if (!isValid) return;
    let formdata = new FormData();
    const { id } = editCommunityItem;
    formdata.append("id", id);
    formdata.append("name", comName);
    formdata.append("description", comDescription);
    formdata.append("tenantLatitude", tenantLat);
    formdata.append("tenantLangitude", tenantLng);
    formdata.append("city", comCity);
    formdata.append("state", comState);
    formdata.append("country", comCountry);
    formdata.append("zipcode", comZipcode);
    formdata.append("address1", comAddress);
    Api.updateCommunityInfo(formdata)
      .then((res) => {
        if (res.data.status === "failed") {
          alert("Community Info Update Failed");
        } else {
          alert("Community Info Updated Successfully");
          fetchTenantList();
          // Remove `changedLatitude` and `changedLongitude` keys
          setEditCommunityItem((prevItem) => {
            const { changedLatitude, changedLongitude, ...rest } = prevItem; // Destructure and omit keys
            return rest;
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      dispatch(moderatorActions.fetchModeratingCommunityList(""));
    }, 1000);
  };

  const onClickCommImgUpload = () => {
    // Trigger the click event on the hidden file input
    fileInputRef.current.click();
  };

  const handleImageChange = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      try {
        const compressedFile = await compressFile(file); //compress file
        const photoUrl = URL.createObjectURL(compressedFile);
        setFile(photoUrl);

        const formData = new FormData();
        const uploadFile = compressedFile || file;
        formData.append("img", uploadFile, uploadFile.name || file.name);
        const { id } = editCommunityItem;
        await Api.uploadCommunityImage(id, formData);
        alert("Community image updated successfully");
        dispatch(moderatorActions.fetchModeratingCommunityList(""));
      } catch (err) {
        console.error(err);
      }
    }
  };

  const communityImg = file
    ? file
    : editCommunityItem?.thumbnailLogo
    ? `${ImagePath}${editCommunityItem?.thumbnailLogo}`
    : CommunityImage;

  return (
    <>
      <form onSubmit={onSubmit}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <CommunityInfoInput
            placeholdertext={"Enter Community Name"}
            labelText="Community Name"
            onChangeHandler={setComName}
            // styleClass="communityNameInput"
            styleClass={styles.communityNameInputField}
            value={comName}
            isInputTextHandler={true}
            charLength={50}
          />
          <CommunityInfoInput
            placeholdertext={"Enter Description"}
            labelText="Description"
            onChangeHandler={setComDescription}
            styleClass={styles.descriptionInputField}
            value={comDescription}
            isInputTextHandler={true}
            charLength={280}
          />

          <CommunityInfoInput
            labelText="Country"
            country_list={countries}
            onChangeHandler={onCountryChange}
            value={comCountry}
          />

          <div className="addressandcity">
            <CommunityInfoInput
              // placeholdertext={"18900 Prospect Road"}
              placeholdertext={"Enter Address"}
              labelText="Address"
              onChangeHandler={setComAddress}
              styleClass={styles.communityNameInputField}
              parentStyleClass="mediumInput1"
              value={comAddress}
              isInputTextHandler={true}
              charLength={50}
            />
            <CommunityInfoInput
              // placeholdertext={"18900 Prospect Road"}
              placeholdertext={"Enter City"}
              labelText="City"
              onChangeHandler={setComCity}
              styleClass={styles.communityNameInputField}
              parentStyleClass="mediumInput2"
              value={comCity}
              isInputTextHandler={true}
              charLength={50}
            />
          </div>
          <div className="addressandcity">
            {tenant_list && Object.keys(tenant_list).length !== 0 ? (
              <CommunityInfoInput
                labelText="State"
                parentStyleClass="mediumInput1"
                state_list={statesList}
                value={comState}
                onChangeHandler={onStateChange}
              />
            ) : null}
            <CommunityInfoInput
              placeholdertext={"Enter Zip code"}
              labelText="Zip Code"
              onChangeHandler={setComZipCode}
              styleClass={styles.communityNameInputField}
              parentStyleClass="mediumInput2"
              value={comZipcode}
              isInputTextHandler={true}
              charLength={15}
            />
          </div>
          <div>
            <button onClick={mapCommunity} className={styles.mapCommBtn}>
              <img
                src={MapIcon}
                alt="Map-Icon"
                className={styles.mapCommunityImage}
              />
              &nbsp;Edit Community Map
            </button>
          </div>

          <div>
            <button
              className={styles.editCommBtn}
              onClick={onClickCommImgUpload}
            >
              <img
                src={communityImg}
                alt="Map-Icon"
                className={styles.editCommImg}
              />
              &nbsp;Edit Community Picture
            </button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              style={{ visibility: "hidden" }}
            />
          </div>

          <button
            type="submit"
            variant="contained"
            onClick={onSave}
            className={styles.button}
          >
            Save
          </button>
        </div>
      </form>

      <Modal
        open={openErrorModal}
        onClose={handleCloseErrorModal}
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            id="error-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Please fix the following errors:
          </Typography>

          {Object.values(fieldErrors).map((err, index) => (
            <Typography key={index} color="error" sx={{ mb: 1 }}>
              • {err}
            </Typography>
          ))}

          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseErrorModal}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </Box>
      </Modal>

      {isOpen ? (
        <Dialog
          open={isOpen}
          onClose={handleClose}
          classes={{ paperWidthSm: classes.paperWidthSm }}
        >
          <DialogTitle
            disableTypography
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "-5px",
              marginBottom: "5px",
            }}
            sx={{ padding: 0 }}
          >
            <h5 className={styles.mapCommunityHeading}>Map Community</h5>
            <button className={styles.closeIcon} onClick={handleClose}>
              <img src={CloseBtn} alt="Close-Button" />
            </button>
          </DialogTitle>
          <EditMap
            {...editCommunityItem}
            onMapClose={handleClose}
            getLatLng={getLatLng}
            selectedCountry={comCountry}
          />
        </Dialog>
      ) : null}
    </>
  );
};

export default CommunityInfo;
